import {UntypedFormControl, Validators} from '@angular/forms';
import {RangeValidator} from '../validator/range-validator';
import {ValidatorRegex} from '../validator/validator-enum';

interface MeasurementFormConfigInterface {
  featureName: UntypedFormControl;
  featureType: UntypedFormControl;
  featureDescription: UntypedFormControl;
  xCoordinateMeasurement: UntypedFormControl;
  yCoordinateMeasurement: UntypedFormControl;
  zCoordinateMeasurement: UntypedFormControl;
  endDate: UntypedFormControl;
  distance: UntypedFormControl;
  directionFrom: UntypedFormControl;
  directionTo: UntypedFormControl;
  napToALatConversion: UntypedFormControl;
}

export const TidalStreamMeasurementFormConfig: MeasurementFormConfigInterface = {
  featureName: new UntypedFormControl(null, [Validators.maxLength(40), Validators.required]),
  featureType: new UntypedFormControl(null, [Validators.required]),
  featureDescription: new UntypedFormControl(null, [Validators.maxLength(254), Validators.required]),
  xCoordinateMeasurement: new UntypedFormControl(null, [
    Validators.required,
    Validators.pattern(ValidatorRegex.Decimal),
  ]),
  yCoordinateMeasurement: new UntypedFormControl(null, [
    Validators.required,
    Validators.pattern(ValidatorRegex.Decimal),
  ]),
  zCoordinateMeasurement: new UntypedFormControl(null, [
    Validators.pattern(ValidatorRegex.Decimal),
  ]),
  endDate: new UntypedFormControl(null, [
  ]),
  distance: new UntypedFormControl(null, [
    Validators.required,
    Validators.pattern(ValidatorRegex.PositiveInteger),
  ]),
  directionFrom: new UntypedFormControl(null, [
    Validators.required,
    Validators.pattern(ValidatorRegex.PositiveInteger),
    RangeValidator.validate(0, 359),
  ]),
  directionTo: new UntypedFormControl(null, [
    Validators.required,
    Validators.pattern(ValidatorRegex.PositiveInteger),
    RangeValidator.validate(0, 359),
  ]),
  napToALatConversion: new UntypedFormControl(null, [
    Validators.pattern(ValidatorRegex.Decimal),
  ]),
};

export const GenericMeasurementFormConfig: MeasurementFormConfigInterface = {
  featureName: new UntypedFormControl(null, [Validators.maxLength(40), Validators.required]),
  featureType: new UntypedFormControl(null, [Validators.required]),
  featureDescription: new UntypedFormControl(null, [Validators.maxLength(254), Validators.required]),
  xCoordinateMeasurement: new UntypedFormControl(null, [
    Validators.required,
    Validators.pattern(ValidatorRegex.Decimal),
  ]),
  yCoordinateMeasurement: new UntypedFormControl(null, [
    Validators.required,
    Validators.pattern(ValidatorRegex.Decimal),
  ]),
  zCoordinateMeasurement: new UntypedFormControl(null, [
    Validators.pattern(ValidatorRegex.Decimal),
  ]),
  endDate: new UntypedFormControl(null, [
  ]),
  distance: new UntypedFormControl(null, [
    Validators.pattern(ValidatorRegex.PositiveInteger),
  ]),
  directionFrom: new UntypedFormControl(null, [
    Validators.pattern(ValidatorRegex.PositiveInteger),
    RangeValidator.validate(0, 359),
  ]),
  directionTo: new UntypedFormControl(null, [
    Validators.pattern(ValidatorRegex.PositiveInteger),
    RangeValidator.validate(0, 359),
  ]),
  napToALatConversion: new UntypedFormControl(null, [
    Validators.pattern(ValidatorRegex.Decimal),
  ]),
};


export const HeightOfTideMeasurementFormConfig: MeasurementFormConfigInterface = {
  featureName: new UntypedFormControl(null, [Validators.maxLength(40), Validators.required]),
  featureType: new UntypedFormControl(null, [Validators.required]),
  featureDescription: new UntypedFormControl(null, [Validators.maxLength(254), Validators.required]),
  xCoordinateMeasurement: new UntypedFormControl(null, [
    Validators.required,
    Validators.pattern(ValidatorRegex.Decimal),
  ]),
  yCoordinateMeasurement: new UntypedFormControl(null, [
    Validators.required,
    Validators.pattern(ValidatorRegex.Decimal),
  ]),
  zCoordinateMeasurement: new UntypedFormControl(null, [
    Validators.pattern(ValidatorRegex.Decimal),
  ]),
  endDate: new UntypedFormControl(null, [
  ]),
  distance: new UntypedFormControl(null, [
    Validators.pattern(ValidatorRegex.PositiveInteger),
  ]),
  directionFrom: new UntypedFormControl(null, [
    Validators.pattern(ValidatorRegex.PositiveInteger),
    RangeValidator.validate(0, 359),
  ]),
  directionTo: new UntypedFormControl(null, [
    Validators.pattern(ValidatorRegex.PositiveInteger),
    RangeValidator.validate(0, 359),
  ]),
  napToALatConversion: new UntypedFormControl(null, [
    Validators.required,
    Validators.pattern(ValidatorRegex.Decimal),
  ]),
};
